import React from "react";
import "./Blogs_card.css";

function Blogs_card({
  blog = [],
  handleServiceClick,
  htmlToReactParser,
  IMG_URL,
  IDS,
}) {
  return (
    <div className="blog_grid">
      {blog.map((item) => {
        const imagePath =
          item?.image || item?.blog_image || item?.thumbnail || "";

        const bgImage = imagePath.startsWith("http")
          ? imagePath
          : `${IDS?.IMG_URL || IMG_URL}${imagePath}`;

        const currentTags = item.pop_tag_id || item.tags || [];

        return (
     
              <div
                key={item.id}
                className="blog_card"
                onClick={() =>
                  handleServiceClick && handleServiceClick(item.id)
                }
              >
                {/* Image */}
                <div className="blog_img_container">
                  <img src={bgImage} alt={item.title} className="blog_img" />
                </div>

                {/* Content */}
                <div className="blog_overlay">
                  <div className="blog_meta">
                    {/* Tags */}
                    {currentTags.length > 0 && (
                      <div className="card_tags_container">
                        {currentTags
                          .filter((tag) => tag?.label)
                          .map((tag, idx) => (
                            <span
                              key={`${tag.value || idx}-${idx}`}
                              className="blog_tag_badge"
                            >
                              {tag.label}
                            </span>
                          ))}
                      </div>
                    )}

                    <span className="date">
                      {item.createdAt
                        ? new Date(item.createdAt).toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })
                        : "Recent"}
                    </span>
                  </div>

                  <h3 className="blog_title">{item.title}</h3>

                  <div className="blog_desc">
                    {item.description
                      ? htmlToReactParser.parse(item.description)
                      : item.desc}
                  </div>

                  <span className="read_more_span">Read more →</span>
                </div>
              </div>
        );
      })}
    </div>
  );
}

export default Blogs_card;
